export default __webpack_public_path__ + "static/media/Seal of Anarchy.09da9dc9.jpg";